


















import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { COMMENT_FEED } from "@/services/earn_coins/earn_coins_consts/earn_coins_consts";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
export default class PostFeed extends Vue {
  @Prop()
  private resource: any;

  // private post_image_src = "";

  get userName() {
    if (this.resource && this.resource.username) {
      return this.resource.username;
    } else {
      return "";
    }
  }

  get placeHolder() {
    return require("@/assets/icons-file/sku/placehold_post.png");
  }

  get feedCommentShow() {
    return this.resource && this.resource.kind === COMMENT_FEED;
  }

  get feedComment() {
    if (
      this.resource &&
      this.resource.comment &&
      this.resource.comment.content
    ) {
      return this.resource.comment.content;
    } else {
      return "";
    }
  }

  /**
   *  tt_video :1.Referer:https://www.tiktok.com/ 2. Cookie
   */
  get postImageSrc() {
    return (
      this.resource &&
      (this.resource.image_high ||
        this.resource.image_low ||
        this.resource.image_thumb)
    );
  }

  get postMediaId() {
    return this.resource && this.resource.media_id;
  }
}
